import { render, staticRenderFns } from "./Recents.vue?vue&type=template&id=929f9102&scoped=true&"
import script from "./Recents.vue?vue&type=script&lang=js&"
export * from "./Recents.vue?vue&type=script&lang=js&"
import style0 from "./Recents.vue?vue&type=style&index=0&id=929f9102&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929f9102",
  null
  
)

export default component.exports